import React, { useState, useEffect, useRef } from 'react';
import StatCard from '../components/StatCard';
import { 
  Shield, ShieldCheck, Briefcase, FileText, MessageSquare, Settings, Search, Bell, User, Lock, LogOut, MoreVertical, 
  Download, Upload, Plus, CheckCircle2, Clock, Eye, Layers, X, ChevronRight, ChevronLeft, 
  FilePlus2, ArrowUp, ArrowDown, CheckSquare, CalendarDays, ArrowRight, Edit, Trash2, Save, Calendar, 
  MapPin, Gavel, Users, Receipt, Banknote, RefreshCw, Mail, Sliders, ArrowDownAZ, Image as ImageIcon, FileEdit, 
  MoveUp, MoveDown, RotateCw, Settings2, Database, UserCog, Scan, Printer, MonitorDown, Copy, FolderSync, Menu, Paperclip, ExternalLink, Folder, FolderOpen, UploadCloud
} from 'lucide-react';
import { ROLE_NAMES, formatHebDate, handleDownloadLocalFile } from '../utils';

export default function DashboardView({ cases, documents, hearings, tasks }) {
  const activeCasesCount = cases.filter(c => c.status === 'פעיל').length;
  const docsCount = documents.length;
  const upcomingHearingsCount = hearings.length; 
  const upcomingTasks = tasks.filter(t => t.status === 'pending' || t.status === 'overdue').slice(0, 4);

  const auditLogs = []; 

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        <StatCard title="תיקים פעילים" value={activeCasesCount} icon={<Briefcase className="w-6 h-6 text-blue-600" />} trend="מתוך מסד הנתונים" />
        <StatCard title="מסמכים בכספת" value={docsCount} icon={<FileText className="w-6 h-6 text-indigo-600" />} trend="סונכרן בענן" />
        <StatCard title="דיונים קרובים" value={upcomingHearingsCount} icon={<Clock className="w-6 h-6 text-amber-500" />} trend="קבועים ביומן" alert={upcomingHearingsCount > 0} />
        <StatCard title="התראות אבטחה" value="0" icon={<ShieldCheck className="w-6 h-6 text-emerald-600" />} trend="המערכת מאובטחת" success />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="font-bold text-lg text-slate-800">משימות ותאריכי יעד קרובים</h3>
          </div>
          <div className="space-y-4">
            {upcomingTasks.length === 0 ? <p className="text-sm text-slate-500">אין משימות קרובות כרגע.</p> : 
              upcomingTasks.map((task, i) => (
                <div key={task._id || i} className="flex items-center gap-4 p-3 hover:bg-slate-50 rounded-lg border border-slate-100 transition-colors">
                  <div className={`w-2 h-10 rounded-full shrink-0 ${task.status === 'overdue' ? 'bg-red-500' : 'bg-blue-500'}`}></div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-medium text-slate-800 truncate">{task.title}</h4>
                    <p className="text-sm text-slate-500 flex items-center gap-1 mt-1 truncate">
                      <Clock className="w-3 h-3 shrink-0" /> יעד: {formatHebDate(task.deadline)}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <div className="flex items-center gap-2 mb-6 pb-4 border-b border-slate-100">
            <Shield className="w-5 h-5 text-slate-700" />
            <h3 className="font-bold text-lg text-slate-800">יומן אבטחה ענן (Audit Log)</h3>
          </div>
          <div className="space-y-5">
            {auditLogs.length === 0 ? (
               <p className="text-sm text-slate-400 text-center py-4">אין התראות אבטחה אחרונות.</p>
            ) : (
              auditLogs.map((log) => (
                <div key={log.id} className="relative pl-4 border-r-2 border-slate-200 pr-4">
                  <div className={`absolute -right-[9px] top-1 w-4 h-4 rounded-full border-4 border-white ${log.action.includes('נדחה') ? 'bg-red-500' : 'bg-slate-400'}`}></div>
                  <p className="text-sm font-medium text-slate-800">{log.action}</p>
                  <div className="flex items-center justify-between mt-1 text-xs text-slate-500">
                    <span className="truncate">{log.user}</span>
                    <span dir="ltr" className="shrink-0">{log.ip}</span>
                  </div>
                  <p className="text-xs text-slate-400 mt-0.5">{log.time}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
